import backendAxios from '../utils/backendAxios';
import {
  GET_CHATS,
  GET_MESSAGES,
  ADD_MESSAGE,
  SET_CURRENT_CHAT,
  CHAT_ERROR,
  TOGGLE_CHAT,
  MARK_CHAT_READ,
  DELETE_CHAT
} from './types';

// ... (other actions stay the same)

// Delete a chat logically
export const deleteChat = (chatId) => async dispatch => {
  try {
    await backendAxios.delete(`/api/chat/${chatId}`);
    dispatch({
      type: DELETE_CHAT,
      payload: chatId
    });
  } catch (err) {
    console.error('Error deleting chat:', err);
    dispatch({
      type: CHAT_ERROR,
      payload: { msg: "Error al eliminar conversación" }
    });
  }
};

// Cada cuánto se permite reenviar el mensaje automático de "Cotizar" (24h)
const COTIZAR_THROTTLE_MS = 24 * 60 * 60 * 1000;

// Decide si se debe enviar el mensaje automático: solo una vez cada 24h por
// (proveedor + servicio/página), para que al dar click varias veces a "Cotizar"
// no se repita el mismo mensaje en el chat. El usuario sí puede escribir manualmente.
const debeEnviarMensajeAuto = (throttleKey) => {
  if (!throttleKey) return true;
  try {
    const key = `cotizarAuto_${throttleKey}`;
    const ultimo = Number(localStorage.getItem(key)) || 0;
    if (Date.now() - ultimo < COTIZAR_THROTTLE_MS) return false;
    localStorage.setItem(key, String(Date.now()));
    return true;
  } catch (e) {
    // localStorage no disponible (modo privado, etc.): enviar de todos modos
    return true;
  }
};

// Get or create chat
export const startChat = (recipientId, relatedId, relatedType, initialMsg = null, throttleKey = null) => async dispatch => {
  dispatch(toggleChat(true)); // Abrir ventana inmediatamente para dar feedback
  try {
    const res = await backendAxios.post('/api/chat', { recipientId, relatedId, relatedType });
    dispatch(setCurrentChat(res.data));

    // Si hay mensaje inicial, enviarlo solo si no se envió ya en las últimas 24h
    if (initialMsg && debeEnviarMensajeAuto(throttleKey)) {
      dispatch(sendMessage(res.data._id, initialMsg));
    }
  } catch (err) {
    console.error('Error en startChat:', err.response?.data || err.message);
    if (err.message === 'Network Error') {
      console.warn('Posible problema de Mixed Content (HTTPS vs HTTP) o el servidor está apagado.');
    }
    dispatch({
      type: CHAT_ERROR,
      payload: { msg: "Error al iniciar chat" }
    });
  }
};

// Get all chats
export const getChats = () => async dispatch => {
  try {
    const res = await backendAxios.get('/api/chat');
    dispatch({
      type: GET_CHATS,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: CHAT_ERROR,
      payload: { msg: "Error al obtener chats" }
    });
  }
};

// Get messages for a chat
export const getMessages = (chatId) => async dispatch => {
  try {
    const res = await backendAxios.get(`/api/chat/${chatId}/messages`);
    dispatch({
      type: GET_MESSAGES,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: CHAT_ERROR,
      payload: { msg: "Error al obtener mensajes" }
    });
  }
};

// Send a message
export const sendMessage = (chatId, content, quoteId = null, type = 'text') => async (dispatch, getState) => {
  try {
    const res = await backendAxios.post(`/api/chat/${chatId}/message`, { content, quote: quoteId, type });
    const state = getState();
    const authUser = state.auth.user || state.user?.user;
    dispatch({
      type: ADD_MESSAGE,
      payload: { ...res.data, userId: authUser?._id }
    });
  } catch (err) {
    dispatch({
      type: CHAT_ERROR,
      payload: { msg: "Error al enviar mensaje" }
    });
  }
};

// Add message from socket
export const addSocketMessage = (message, chatId, userId) => dispatch => {
  dispatch({
    type: ADD_MESSAGE,
    payload: { ...message, chat: chatId, userId }
  });
};

// Mark chat as read
export const markAsRead = (chatId) => async dispatch => {
  try {
    await backendAxios.patch(`/api/chat/${chatId}/read`);
    dispatch({
      type: MARK_CHAT_READ,
      payload: chatId
    });
  } catch (err) {
    console.error('Error marking as read:', err);
  }
};

// Set current chat
export const setCurrentChat = (chat) => dispatch => {
  dispatch({
    type: SET_CURRENT_CHAT,
    payload: chat
  });
  if (chat) {
    dispatch(getMessages(chat._id));
    dispatch(markAsRead(chat._id));
  }
};

export const toggleChat = (open) => dispatch => {
  dispatch({
    type: TOGGLE_CHAT,
    payload: open
  });
};
